export default __webpack_public_path__ + "db1d918a6ac8ea3d2123c5c130170f6b.png";